import { render, staticRenderFns } from "./physicians-table.vue?vue&type=template&id=7ae8ee66&scoped=true"
import script from "./physicians-table.vue?vue&type=script&lang=js"
export * from "./physicians-table.vue?vue&type=script&lang=js"
import style0 from "./physicians-table.vue?vue&type=style&index=0&id=7ae8ee66&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae8ee66",
  null
  
)

export default component.exports